import React from 'react';
import {
  Button,
} from 'reactstrap';

const ButtonComponent = (props) => {
  const data = props;
  return (
    <Button
      className="btn_submit m-auto p-3"
      type="submit"
      onClick={data.onClick}
      disabled={data.disabled}
      size="lg"
      block
      style={{
        width: data.width, borderRadius: '30px', background: data.background, borderColor: data.borderColor,
      }}
    >
      <span
        className="text-center"
        style={{
          letterSpacing: '0.3rem', color: data.color,
        }}
      >
        {data.children}
      </span>
    </Button>
  );
};

export default ButtonComponent;
